import { makeEnum } from "../../utils/enumUtils.js";

// ============================================
// COMMON STATUS PATTERNS
// ============================================

// Active/Inactive status
export const {
  ENUM: ACTIVE_INACTIVE_STATUS,
  VALUES: ACTIVE_INACTIVE_STATUS_VALUES,
} = makeEnum({
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
});

// Active/Inactive/Archived status
export const {
  ENUM: ACTIVE_INACTIVE_ARCHIVED_STATUS,
  VALUES: ACTIVE_INACTIVE_ARCHIVED_STATUS_VALUES,
} = makeEnum({
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  ARCHIVED: "ARCHIVED",
});

// Approval status
export const { ENUM: APPROVAL_STATUS, VALUES: APPROVAL_STATUS_VALUES } =
  makeEnum({
    PENDING: "PENDING",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
  });

// ============================================
// PRIORITY LEVELS
// ============================================

// Priority levels
export const { ENUM: PRIORITY_LEVELS, VALUES: PRIORITY_VALUES } = makeEnum({
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  CRITICAL: "CRITICAL",
});

// Priority levels with urgent
export const {
  ENUM: PRIORITY_LEVELS_WITH_URGENT,
  VALUES: PRIORITY_WITH_URGENT_VALUES,
} = makeEnum({
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  URGENT: "URGENT",
});

// ============================================
// IDENTIFICATION TYPES
// ============================================

// Identification types
export const {
  ENUM: IDENTIFICATION_TYPES,
  VALUES: IDENTIFICATION_TYPE_VALUES,
} = makeEnum({
  NATIONAL_ID: "NATIONAL_ID",
  IQAMA: "IQAMA",
  PASSPORT: "PASSPORT",
});

// ============================================
// PERSONAL INFORMATION
// ============================================

// Gender types
export const { ENUM: GENDER_TYPES, VALUES: GENDER_TYPE_VALUES } = makeEnum({
  MALE: "MALE",
  FEMALE: "FEMALE",
  OTHER: "OTHER",
});

// Marital status types
export const {
  ENUM: MARITAL_STATUS_TYPES,
  VALUES: MARITAL_STATUS_VALUES,
} = makeEnum({
  SINGLE: "SINGLE",
  MARRIED: "MARRIED",
  DIVORCED: "DIVORCED",
  WIDOWED: "WIDOWED",
});



// ============================================
// ENTITY/OWNERSHIP TYPES
// ============================================

// Entity types
export const { ENUM: ENTITY_TYPE, VALUES: ENTITY_TYPE_VALUES } = makeEnum({
  INDIVIDUAL: "INDIVIDUAL",
  COMPANY: "COMPANY",
  PARTNERSHIP: "PARTNERSHIP",
});



// ============================================
// IMPACT/ADJUSTMENT PATTERNS
// ============================================

// Impact direction
export const { ENUM: IMPACT_DIRECTION, VALUES: IMPACT_DIRECTION_VALUES } =
  makeEnum({
    INCREASE: "INCREASE",
    DECREASE: "DECREASE",
  });

// Impact type
export const { ENUM: IMPACT_TYPE, VALUES: IMPACT_TYPE_VALUES } = makeEnum({
  PERCENTAGE: "PERCENTAGE",
  FIXED: "FIXED",
});

// ============================================
// COMPARISON OPERATORS
// ============================================

// Comparison operators
export const {
  ENUM: COMPARISON_OPERATORS,
  VALUES: COMPARISON_OPERATOR_VALUES,
} = makeEnum({
  GREATER_THAN: ">",
  LESS_THAN: "<",
  GREATER_THAN_OR_EQUAL: ">=",
  LESS_THAN_OR_EQUAL: "<=",
});

// ============================================
// CURRENCY
// ============================================

// Currency types
export const { ENUM: CURRENCY, VALUES: CURRENCY_VALUES } = makeEnum({
  SAR: "SAR",
});

// ============================================
// DATE TYPES
// ============================================

// Date types
export const { ENUM: DATE_TYPES, VALUES: DATE_TYPE_VALUES } = makeEnum({
  RANGE: "RANGE",
  SPECIFIC: "SPECIFIC",
  RECURRING: "RECURRING",
});

// ============================================
// SCOPE TYPES
// ============================================

// Scope types
export const { ENUM: SCOPE_TYPES, VALUES: SCOPE_TYPE_VALUES } = makeEnum({
  BUILDING: "BUILDING",
  FLOOR: "FLOOR",
  ROOM: "ROOM",
});

// ============================================
// IMAGE/MEDIA FORMATS
// ============================================

// Image formats
export const { ENUM: IMAGE_FORMATS, VALUES: IMAGE_FORMAT_VALUES } = makeEnum({
  WEBP: "webp",
});

// ============================================
// NODE TYPES (Sidebar / Tree)
// ============================================

// Node types
export const { ENUM: NODE_TYPES, VALUES: NODE_TYPE_VALUES } = makeEnum({
  GROUP: "GROUP",
  MODULE: "MODULE",
});

// ============================================
// TWO FACTOR AUTHENTICATION
// ============================================

// Two factor authentication methods
export const { ENUM: TWO_FACTOR_METHODS } = makeEnum({
  TOTP: "TOTP",
  SMS: "SMS",
  EMAIL: "EMAIL",
  NONE: null,
});

export const TWO_FACTOR_METHOD_VALUES = Object.freeze(
  Object.values(TWO_FACTOR_METHODS).filter((v) => v !== null)
);

// ============================================
// OTP VERIFICATION
// ============================================

// OTP purpose types
export const { ENUM: OTP_PURPOSE, VALUES: OTP_PURPOSE_VALUES } = makeEnum({
  REGISTRATION: "REGISTRATION",
  GENERIC: "GENERIC",
});

// ============================================
// AUDIENCE TYPES
// ============================================

// Audience types
export const { ENUM: AUDIENCE_TYPES, VALUES: AUDIENCE_TYPE_VALUES } = makeEnum({
  PUBLIC: "PUBLIC",
  GOVERNMENT: "GOVERNMENT",
});
